export * from "ce/entities/URLRedirect/URLAssembly";
import { default as CE_urlBUilder } from "ce/entities/URLRedirect/URLAssembly";
export default CE_urlBUilder;
